skrilla.directive('systemDefaultBets',function() {
    return {
        templateUrl: 'directives/defaultBetLimits/systemDefaultBets.html',
        scope: {
        },
        controller: function($scope, paginationService, queryService, searchService, currencyService, modalService){
            $scope.key = "nonDefaultBetLimits"
            $scope.reset = function(){
                $scope.query = {limit: 20};
            }
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getDefaults, $scope.key);
            }
            $scope.saveLimit = function(limit){
                console.log(limit)
                modalService.confirm("Are you sure you'd like to update the default " + limit.currency + " bet limits?",function() {
                    limit.maximumStake = currencyService.multiply(limit.maximumStake, limit.currency);
                    limit.maximumDailyStake = currencyService.multiply(limit.maximumDailyStake, limit.currency);
                    limit.maximumLiability = currencyService.multiply(limit.maximumLiability, limit.currency);
                    searchService.put("limits/bets/default", limit, "Default " + limit.currency + " bet limits Successfully updated!").then(function (response) {
                        $scope.defaultBetLimits = response.data.result.map(function (m) {
                            m.maximumStake = currencyService.divide(m.maximumStake, m.currency)
                            m.maximumDailyStake = currencyService.divide(m.maximumDailyStake, m.currency)
                            m.maximumLiability = currencyService.divide(m.maximumLiability, m.currency)
                            return m
                        });
                    });
                });
            }

            var getDefaults = function() {
                return searchService.get("limits/bets" + queryService.getQueryString($scope.query, $scope.key)).then(function(response) {
                    $scope.limits = response.data.result;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            searchService.get("limits/bets/default").then(function (response) {
                $scope.defaultBetLimits = response.data.result.map(function (m) {
                    m.maximumStake = currencyService.divide(m.maximumStake, m.currency)
                    m.maximumDailyStake = currencyService.divide(m.maximumDailyStake, m.currency)
                    m.maximumLiability = currencyService.divide(m.maximumLiability, m.currency)
                    return m
                });
            });

            $scope.search();
        }
    };
});
